/** Dashboard widget: overall market trend, breadth, and fear/greed. */

import React, { useEffect, useState } from "react";
import { apiClient } from "@/api/client";
import type { MarketSnapshot } from "@/types";
import WidgetCard from "./WidgetCard";

const TREND_COLOR: Record<string, string> = {
  bullish: "text-signal-teal",
  neutral: "text-signal-amber",
  bearish: "text-signal-rose",
};

export default function MarketStatusWidget(): React.ReactElement {
  const [snapshot, setSnapshot] = useState<MarketSnapshot | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    apiClient
      .get<MarketSnapshot>("/market/snapshot/latest")
      .then(({ data }) => setSnapshot(data))
      .catch(() => setError(null)) // no snapshot yet is a normal empty state, not an error
      .finally(() => setLoaded(true));
  }, []);

  return (
    <WidgetCard title="Market status" isLoading={!loaded} error={error}>
      {snapshot ? (
        <>
          <p className={`text-2xl font-semibold capitalize ${TREND_COLOR[snapshot.trend]}`}>
            {snapshot.trend}
          </p>
          <p className="text-xs text-mist-400">
            {snapshot.advancers ?? "—"} advancers / {snapshot.decliners ?? "—"} decliners
          </p>
          {snapshot.fear_greed_index !== null && (
            <p className="text-xs text-mist-400">Fear &amp; Greed: {snapshot.fear_greed_index}/100</p>
          )}
        </>
      ) : (
        <p className="text-sm text-mist-400">No market snapshot recorded yet.</p>
      )}
    </WidgetCard>
  );
}
